module.exports = __webpack_public_path__ + "img/luck_pak.0ecdd952.png";